export const environment = {
  production: false,
  apiUrl: 'https://kga-pos-api-uat.azurewebsites.net/',
  baseUrl: 'https://kga-pos-webapp-uat.azurewebsites.net/',
  baseLoginUrl : 'https://kga-masterlogin-webapp-uat.azurewebsites.net',
  version: 'V1.0.5'
};
